import {
  SET_USER_PROFILE,
  UPDATE_USER_PROFILE,
  SET_USER_SPACES
} from "./types";
import * as services from "../services/api";

export default {
  namespaced: true,
  state: {
    info: {},
    profile: {},
    preferences: {},
    spaces: []
  },

  getters: {
    spaces(state) {
      return state.spaces.map(({ space, interest }) => ({
        id: space.id,
        name: space.space_name,
        postCount: space.posts_summary.count,
        interest: {
          id: interest.id,
          name: interest.name
        }
      }));
    }
  },

  mutations: {
    [SET_USER_SPACES](state, spaces) {
      state.spaces = spaces;
    },

    [SET_USER_PROFILE](state, data) {
      state.info = data.info;
      state.profile = data.profile;
    },

    [UPDATE_USER_PROFILE](state, data) {
      state.info = { ...state.info, ...data.info };
      state.profile = { ...state.profile, ...data.profile };
    }
  },

  actions: {
    async fetchUserProfile({ commit }) {
      let data = await services.getUserProfile();
      commit(SET_USER_PROFILE, {
        info: data.basic_info,
        profile: data.profile
      });
    },

    async fetchUserSpaces(
      { commit, state },
      { only_active, marker, page_size }
    ) {
      let data = await services.getUserSpaces(
        state.info.id,
        only_active,
        marker,
        page_size
      );
      commit(SET_USER_SPACES, data.results);
    },

    async updateUserProfile({ commit }, { info, profile }) {
      return services
        .updateUserProfile({ ...info, profile })
        .then(() => commit(UPDATE_USER_PROFILE, { info, profile }));
    },

    async updateUserPassword(context, { currPassword, newPassword }) {
      return services
        .updateUserProfile({
          current_password: currPassword,
          password: newPassword
        })
        .catch(error => {
          if (error.response.status == 400) {
            throw new Error("Invalid current password.");
          } else {
            throw new Error("Something went wrong please try later.");
          }
        });
    }
  }
};
